






































































































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import { db } from '../firebase/init'
import MainMixin from '../mixins/MainMixin'
import EventBus from '../event-bus'
import CardList from '../components/layout/CardList.vue'
import { CustomerType, CouponType } from '../types'
import FindCoupon from '../components/coupons/FindCoupon.vue'
import SingleCustomer from '../components/customers/SingleCustomer.vue'
import SingleCoupon from '../components/coupons/SingleCoupon.vue'
import AddCoupon from '../components/coupons/AddCoupon.vue'

function isEmail (text: string) {
  return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(text)
}

@Component({
  components: {
    SingleCustomer,
    CardList,
    SingleCoupon,
    AddCoupon,
    FindCoupon,
  },
})
export default class Coupons extends Mixins(MainMixin) {
  tabs = [{ title: 'By Customer', value: 'customer' }, { title: 'By Code', value: 'code' }]

  $unbind: any

  searchInput = ''

  loading = false

  couponLoading = false

  customerData: any = {}

  submissionData = {
    user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
  }

  $refs: any

  async redeemCoupon () {
    console.log('redeeming: ', this.activeCoupon.id)
    const isValid = await this.$refs.redeemForm.validate()
    if (!isValid) return false
    this.loading = true
    const result = await db.collection('coupons').doc(this.activeCoupon.id).update({
      redeemed: new Date(),
      redeemedBy: this.submissionData.user,
      spend: this.activeCoupon.spend,
      redemptionNotes: this.activeCoupon.notes,
      checkNumber: this.activeCoupon.checkNumber,
    })
    console.log('result: ', result)
    this.loading = false
    this.submissionData = {
      user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
    }
    this.activeCoupon = null
    this.showDialog = false
    return this.$toast.success('Coupon Redeemed')
  }

  updatedSearch () {
    if (this.customerData && this.customerData.id) this.$unbind('customerData')
    this.showMap.cannotFindCustomer = false
    this.showMap.cannotFindCoupon = false
    this.customerData = {}
  }

  get customer (): CustomerType | null {
    if (Array.isArray(this.customerData) && this.customerData.length > 0 && this.customerData[0].id) {
      return this.customerData[0]
    } if (typeof this.customerData === 'object' && this.customerData !== null && this.customerData.id) return this.customerData
    return null
  }

  coupons: CouponType[] | null = null

  get searchIsEmail () {
    return isEmail(this.searchInput)
  }

  showMap = { cannotFindCustomer: false, cannotFindCoupon: false }

  showDialog = false

  activeCoupon: any = {}

  showcoupon (data: any) {
    console.log('coupon data is: ', data)
    this.showDialog = true
    this.activeCoupon = data
  }

  async bindCustomer () {
    this.loading = true
    this.coupons = null
    const search = this.searchInput.trim().toLowerCase()
    console.log('searching for ', search)
    let result
    if (!this.searchIsEmail) {
      result = await this.$bind('customerData', db.collection('customers').doc(`f${search}`))
      if (!result) this.showMap.cannotFindCustomer = true
    } else {
      result = await this.$bind('customerData', db.collection('customers').where('email', '==', search))
      if (result && result.length === 0) this.showMap.cannotFindCustomer = true
    }
    console.log('result is: ', result)
    this.loading = false
  }

  async bindCoupons () {
    this.couponLoading = true
    if (!this.customer || !this.customer.id) throw new Error('Cannot Bind to Unknown Customer)')
    const result = await this.$bind('coupons', db.collection('coupons')
      .where('customer', '==', this.customer.id)
      .where('group', '==', this.$store.getters.group)
      .orderBy('created', 'desc')
      .limit(20))
    console.log('Coupon result: ', result)
    this.couponLoading = false
  }

  searchCode = ''

  foundCoupon: any = null

  async findCoupon () {
    this.couponLoading = true
    const result = await db.collection('anonCoupons').where('codes', 'array-contains', this.searchCode.trim().toUpperCase()).get()
    if (!result || result.empty) {
      this.couponLoading = false
      this.showMap.cannotFindCoupon = true
      return false
    }
    console.log('Coupon result: ', result.docs[0].data())
    this.foundCoupon = result.docs[0].data()
    this.couponLoading = false
    return true
  }
}
